<template>
    <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                {{Core.Definition.getDefinition('Contrat')}}
            </div>

            <b-row>
                <b-col>
                    <DynamicForm
                            v-model="dataId"
                            ref="dynamicForm"
                            getRoot="/contract"
                            saveRoot="/contract"
                            @onTrashClick="onTrashClick"
                            :formStructure="dataFormStructures.contract">
                        <slot slot="beforeFormButtons">
                            <b-button v-if="false" variant="light">{{Core.Definition.getDefinition('Aperçu')}}</b-button>
                        </slot>
                        <slot slot="bottomForm">
                            <b-row v-if="Core.Validation.isId(dataId)" class="mt-2">
                                <b-col class="text-right">
                                    <hr/>
                                    <Request
                                            ref="requestSend"
                                            :options="{
                                                    showAlert: true,
                                                    blockOnProcessing: false,
                                                    blockTransparent: false
                                            }"
                                            method="POST"
                                            root="/contract/send"
                                            :onRequestSuccess="onRequestSendSuccess">
                                        <slot slot="body">
                                            <b-button-group class="mr-2">
                                                <b-input v-model="dataSend.recipient" :placeholder="Core.Definition.getDefinition('Destinataire')" type="text"></b-input>
                                                <b-button :disabled="dataSend.processing" @click="onSendClick" variant="success">{{Core.Definition.getDefinition('Envoyer')}}</b-button>
                                            </b-button-group>
                                        </slot>
                                    </Request>
                                    <br/>
                                    <small class="text-muted">
                                        {{Core.Definition.getDefinition('Le destinataire recevera un lien pour compléter le formulaire et approuver le contrat. Vous ne pourrez plus modifier le contrat.')}}
                                    </small>
                                </b-col>
                            </b-row>
                        </slot>
                    </DynamicForm>
                </b-col>
            </b-row>
        </b-card>

        <ModalTrash
                ref="trash"
                root="/address"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression du contrat')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce contrat?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    import Request from '../../components/Request'
    export default {
        name: 'Contract',
        components: {
            DynamicForm,
            ModalTrash,
            Request
        },
        mounted() {
        },
        data: function () {
            return {
                dataCapsGroups: [],
                Core: window.Core,
                dataId: '',
                dataSend: {
                    recipient: '',
                    processing: false
                },
                dataFormStructures: {
                    contract: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'userId'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'purchaseLink'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'formId'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'content'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'formId',
                                type: 'select',
                                label: Core.Definition.getDefinition('Formulaire à compléter'),
                                value: null,
                                onSelect: function() {},
                                required: false
                            },
                            {
                                id: 'userId',
                                type: 'instanceSelector',
                                label: Core.Definition.getDefinition('Associer à un utilisateur'),
                                value: {
                                    id: '',
                                    label: '',
                                    data: {}
                                },
                                emptyMessage: Core.Definition.getDefinition('Aucun utilisateur sélectionné'),
                                instanceSelector: {
                                    label: [
                                        'firstname',
                                        'lastname'
                                    ],
                                    id: 'id',
                                    root: '/user/list',
                                    searchFormStructure: {
                                        rows: [
                                            {
                                                cols: [
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'firstname'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'lastname'
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                cols: [
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'email'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'phone'
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                cols: [
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'id'
                                                            }
                                                        ]
                                                    },
                                                    {}
                                                ]
                                            }
                                        ],
                                        fields: [
                                            {
                                                id: 'id',
                                                type: 'number',
                                                label: Core.Definition.getDefinition('ID'),
                                                value: ''
                                            },
                                            {
                                                id: 'firstname',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Prénom'),
                                                value: ''
                                            },
                                            {
                                                id: 'lastname',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Nom de famille'),
                                                value: ''
                                            },
                                            {
                                                id: 'phone',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Téléphone'),
                                                value: ''
                                            },
                                            {
                                                id: 'email',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Courriel'),
                                                value: ''
                                            }
                                        ]
                                    },
                                    options: {
                                        pagination: true,
                                        header: true,
                                        responsive: false,
                                        striped: true,
                                        headerStyle: '1',
                                        emptyText: Core.Definition.getDefinition('Aucun utilisateur à afficher'),
                                        borderVariant: 'white',
                                        noBody: true
                                    },
                                    columns: [
                                        {
                                            label: Core.Definition.getDefinition('#'),
                                            key: 'id',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Prénom'),
                                            key: 'firstname',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Nom'),
                                            key: 'lastname',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Courriel'),
                                            key: 'email',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Téléphone'),
                                            key: 'phone',
                                            sortable: true
                                        }
                                    ]
                                }
                            },
                            {
                                id: 'purchaseLink',
                                type: 'instanceSelector',
                                label: Core.Definition.getDefinition('Associer à un achat'),
                                value: {
                                    id: '',
                                    label: '',
                                    data: {}
                                },
                                emptyMessage: Core.Definition.getDefinition('Aucun achat sélectionné'),
                                instanceSelector: {
                                    label: [
                                        'purchaseTypeLabel',
                                        'purchaseId'
                                    ],
                                    id: ['purchaseId', 'purchaseType'],
                                    root: '/commerce/purchases',
                                    searchFormStructure: {
                                        rows: [
                                            {
                                                cols: [
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'userFirstname'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'userLastname'
                                                            }
                                                        ]
                                                    },
                                                ]
                                            },
                                            {
                                                cols: [

                                                    {
                                                        fields: [
                                                            {
                                                                id: 'userEmail'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'userPhone'
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        fields: [
                                            {
                                                id: 'userFirstname',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Prénom'),
                                                value: ''
                                            },
                                            {
                                                id: 'userLastname',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Nom de famille'),
                                                value: ''
                                            },
                                            {
                                                id: 'userPhone',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Téléphone'),
                                                value: ''
                                            },
                                            {
                                                id: 'userEmail',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Courriel'),
                                                value: ''
                                            }
                                        ]
                                    },
                                    options: {
                                        pagination: true,
                                        header: true,
                                        responsive: false,
                                        striped: true,
                                        headerStyle: '1',
                                        emptyText: Core.Definition.getDefinition('Aucun achat à afficher'),
                                        borderVariant: 'white',
                                        noBody: true
                                    },
                                    columns: [
                                        {
                                            label: Core.Definition.getDefinition('ID achat'),
                                            key: 'purchaseId',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Type achat'),
                                            key: 'purchaseTypeLabel',
                                            type: 'text',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Prénom'),
                                            key: 'userFirstname',
                                            type: 'text',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Nom de famille'),
                                            key: 'userLastname',
                                            type: 'text',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Produit'),
                                            key: 'productTitle',
                                            type: 'text',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Date de création'),
                                            key: 'creationDate',
                                            type: 'date',
                                            sortable: true
                                        }
                                    ]
                                }
                            },
                            {
                                id: 'content',
                                type: 'editor',
                                label: Core.Definition.getDefinition('Notes supplémentaires'),
                                value: '',
                                required: false
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/commerce/contrats')
            },
            onSendClick() {
                if (this.dataSend.recipient !== '') {
                    this.dataSend.processing = true
                    this.$refs.requestSend.clearArgs()
                    this.$refs.requestSend.addArg('id', this.dataId)
                    this.$refs.requestSend.addArg('recipient', this.dataSend.recipient)
                    this.$refs.requestSend.request()
                }
            },
            onRequestSendSuccess(data) {
                this.dataSend.recipient = ''
                this.dataSend.processing = false
            }
        }
    }
</script>
